// extracted by mini-css-extract-plugin
module.exports = {"body":"form_body_saIdo","left":"form_left_1XEMn","right":"form_right_3VmLS"};